var Utils = Backbone.View.extend({

    initialize:function(){
        var self = this;

        this.wpTrends = {};
        this.wpFields = {};
        this.wpStatuses = {};
        this.wpMethodoPageID = "";
        this.methodoText = "";

        this.trends = {};
        this.trendsSecond = {};

        this.radars = {};
        this.radarsSecond = {};

        this.polarTrends = {};
        this.polarTrendsSecond = {};

        this.fields = {};
        this.fieldsSecond = {};

        this.autocompleteTrends = [];
        this.autocompleteTrendsSecond = [];

        this.sizeRadiuses = {
            "big":33,
            "medium":18,
            "medium2":15,
            "small":13
        };
        this.discSizeRef = 800;

        this.fieldsData = {
            "tech":{ label:"Technologie"},
            "society":{ label:"Sociétal"},
            "business":{ label:"Métiers"}
        };

        this.statusesLabel = {
            "act":"Déploiement",
            "prepare":"Incubation",
            "watch":"Analyse"
        };
    },

    gatherData:function(callback){
        var self = this;
        //return callback();
        this.gatherWPTrends(function(){
            self.gatherWPRadars(function (){
                return callback();
            })
        });
        /*this.gatherTrends(function(){
            self.computeTrends();
            return callback();
        });*/
    },

    gatherWPTrends:function(callback){
        var self = this;
        $.ajax({
            url:"api/getTrends.php",
            method:"GET",
            success:function(data){
                self.computeWPTrends(JSON.parse(data));
                //self.computeWPTrends(JSON_TRENDS);

                self.autocompleteTrends = _.map(self.trends, function(t){
                    return {
                        label:t.trend,
                        value:t.id
                    };
                });

                self.autocompleteTrendsSecond = _.map(self.trendsSecond, function(t){
                    return {
                        label:t.trend,
                        value:t.id
                    };
                });

                self.fields = _.groupBy(self.trends, function(t){
                    return t.field;
                });

                self.fieldsSecond = _.groupBy(self.trendsSecond, function(t){
                    return t.field;
                });

                return callback();
            }
        })
    },

    gatherWPRadars:function(callback){
        var self = this;
        $.ajax({
            url:"api/getRadars.php",
            method:"GET",
            success:function(data){
                var radarsData = JSON.parse(data);
                console.log("radarsData", radarsData);
                var radarsV1 = _.filter(radarsData.posts, function (o){ return o.post_type == "radar"; });
                var radarsSecond = _.filter(radarsData.posts, function (o){ return o.post_type == "radar2"; });
                self.radars = radarsV1;
                self.radarsSecond = radarsSecond;

                return callback();
            }
        })
    },

    saveAnalytics: function (radarType){
        $.ajax({
            url:"api/saveAnalytics.php",
            method:"POST",
            data:{radarType: radarType},
            success: function (){
                
            }
        })
    },

    computeWPTrends:function(wpData){
        var self = this;

        _.each(wpData.posts, function(p){
            if(p.post_type == "trend"){
                var slugTrend = _.str.slugify(p.post_title);
                self.trends[p.ID] = {
                    id:p.ID,
                    slugTrend:slugTrend,
                    field:"tech",
                    at_stake:"",
                    chapo:"",
                    chapo2:"",
                    companies:"",
                    contacts:"",
                    featured:"",
                    featured_text:"",
                    short_label:"",
                    level:"",
                    links:[],
                    linksNew:{},
                    mail:"",
                    size:"",
                    status:"",
                    strLinks:[],
                    tag:"",
                    trend:p.post_title
                };
            }else if(p.post_type == "trend2"){
                var slugTrend = _.str.slugify(p.post_title);
                self.trendsSecond[p.ID] = {
                    id:p.ID,
                    slugTrend:slugTrend,
                    field:"tech",
                    at_stake:"",
                    chapo:"",
                    chapo2:"",
                    companies:"",
                    contacts:"",
                    featured:"",
                    featured_text:"",
                    short_label:"",
                    level:"",
                    links:[],
                    linksNew:{},
                    mail:"",
                    size:"",
                    status:"",
                    strLinks:[],
                    tag:"",
                    trend:p.post_title
                };
            }else if(p.post_type == "field"){
                var slugField = _.str.slugify(p.post_title);
                self.wpFields[p.ID] = {
                    id:p.ID,
                    label:p.post_title,
                    slug:slugField
                };
            }else if(p.post_type == "status"){
                var slugStatus = _.str.slugify(p.post_title);
                self.wpStatuses[p.ID] = {
                    id:p.ID,
                    label:p.post_title,
                    slug:slugStatus
                };
            }else if(p.post_type == "page"){
                self.wpMethodoPageID = p.ID;
                self.methodoText = p.post_content;
            }
        });

        _.each(wpData.relations, function(r){
            var postID = r.post_id;
            if(self.trends[postID] != undefined || self.trendsSecond[postID] != undefined){
                var trendType = "trends";
                if(self.trendsSecond[postID] != undefined){
                    trendType = "trendsSecond";
                }
                if(r.meta_key == "level"){
                    var slugLevel = _.str.slugify(r.meta_value);
                    self[trendType][postID].level = slugLevel;
                }else if(r.meta_key == "size"){
                    var slugSize = _.str.slugify(r.meta_value);
                    self[trendType][postID].size = slugSize;
                }/*else if(r.meta_key == "field"){
                    var slugField = self.wpFields[r.meta_value].slug;
                    switch(slugField){
                        case "technologie": slugField = "tech"; break;
                        case "socle-technique": slugField = "society"; break;
                        case "methode-process": slugField = "business"; break;
                    }
                    self.trends[postID].field = slugField;
                }*/else if(r.meta_key == "status"){
                    var slugStatus = self.wpStatuses[r.meta_value].slug;

                    switch(slugStatus){
                        case "deploiement": slugStatus = "act"; break;
                        case "analyse": slugStatus = "watch"; break;
                        case "incubation": slugStatus = "prepare"; break;
                    }
                    self[trendType][postID].status = slugStatus;
                }else if(r.meta_key == "featured"){
                    self[trendType][postID].featured = r.meta_value;
                }else if(r.meta_key == "featured_text"){
                    self[trendType][postID].featured_text = r.meta_value;
                }else if(r.meta_key == "rubrique_1"){
                    self[trendType][postID].chapo = r.meta_value;
                }else if(r.meta_key == "rubrique_2"){
                    self[trendType][postID].chapo2 = r.meta_value;
                }else if(r.meta_key == "short_label"){
                    self[trendType][postID].short_label = r.meta_value;
                }else if(r.meta_key == "links"){
                    if(r.meta_value !== ""){
                        var trendsIDS = self.getTrendsIDSFromWPString(r.meta_value);
                        _.each(trendsIDS, function(tID){
                            if(self[trendType][tID] != undefined){
                                self[trendType][postID].links.push(self[trendType][tID].slugTrend);
                                self[trendType][postID].strLinks.push(self[trendType][tID].trend);
                            }
                        });
                    }
                } 

                var metaKeysLinkTrends = ["link_1_trend", "link_2_trend", "link_3_trend", "link_4_trend", "link_5_trend", "link_6_trend", "link_7_trend", "link_8_trend", "link_9_trend", "link_10_trend"];
                _.each(metaKeysLinkTrends, function(metaID){
                    if(r.meta_key == metaID) {
                        var incLink = metaID.split("_")[1];
                        if(self[trendType][postID].linksNew[incLink] === undefined) {
                            self[trendType][postID].linksNew[incLink] = {
                                trendID: "",
                                trendSlug: "",
                                trendText: "",
                                linkText: ""
                            }
                        }

                        if(r.meta_value !== "null" && self[trendType][r.meta_value] !== undefined) {
                            self[trendType][postID].linksNew[incLink].trendID = r.meta_value;
                            self[trendType][postID].linksNew[incLink].trendSlug = self[trendType][r.meta_value].slugTrend;
                            self[trendType][postID].linksNew[incLink].trendText = self[trendType][r.meta_value].trend;
                        }
                    }
                });


                var metaKeysLinkTexts = ["link_1_text", "link_2_text", "link_3_text", "link_4_text", "link_5_text", "link_6_text", "link_7_text", "link_8_text", "link_9_text", "link_10_text"];
                _.each(metaKeysLinkTexts, function(metaID){
                    if(r.meta_key == metaID) {
                        var incLink = metaID.split("_")[1];
                        if(self[trendType][postID].linksNew[incLink] === undefined) {
                            self[trendType][postID].linksNew[incLink] = {
                                trendID: "",
                                trendSlug: "",
                                trendText: "",
                                linkText: ""
                            }
                        }

                        if(r.meta_value !== "null") {
                            self[trendType][postID].linksNew[incLink].linkText = r.meta_value;
                        }
                    }
                });
            }
        });

        _.each(wpData.taxonomies, function(taxon){
            var postID = taxon.object_id;
            var taxonID = taxon.term_taxonomy_id;
            var slugField = "";
            switch(taxonID){
                case "4": case "7": slugField = "tech"; break;
                case "3": case "6": slugField = "society"; break;
                case "2": case "5": slugField = "business"; break;
            }
            if(self["trends"][postID] !== undefined) self["trends"][postID].field = slugField;
            else if(self["trendsSecond"][postID] !== undefined) self["trendsSecond"][postID].field = slugField;
        });

        this.computeAutoLinking()
    },

    computeAutoLinking:function(){
        var self = this;
        _.each(this.trends, function(trend, trendID) {
            _.each(trend.links, function(link) {
                var linkedTrend = _.find(self.trends, function(t){ return t.slugTrend == link; });
                if(_.indexOf(linkedTrend.links, trend.slugTrend) == -1){
                    self.trends[linkedTrend.id].links.push(trend.slugTrend);
                }
            })
        })

        _.each(this.trendsSecond, function(trend, trendID) {
            _.each(trend.links, function(link) {
                var linkedTrend = _.find(self.trendsSecond, function(t){ return t.slugTrend == link; });
                if(_.indexOf(linkedTrend.links, trend.slugTrend) == -1){
                    self.trendsSecond[linkedTrend.id].links.push(trend.slugTrend);
                }
            })
        })
    },

    getTrendsIDSFromWPString:function(wpString){
        //a:7:{i:0;s:2:"33";i:1;s:2:"35";i:2;s:2:"36";i:3;s:2:"32";i:4;s:2:"38";i:5;s:2:"21";i:6;s:2:"29";}
        var trendsIDS = [];
        var cInnerObj = (wpString.split("{")[1]).split("}")[0];
        var splitInnerObj = cInnerObj.split(";");
        _.each(splitInnerObj, function(str){
            if(str.charAt(0) == "s"){
                var documentIDWithQuotes = str.split(":")[2];
                var documentID = documentIDWithQuotes.split('"')[1];
                trendsIDS.push(parseInt(documentID, 10));
            }
        });
        return trendsIDS;
    },

    /*
    gatherTrends:function(callback){
        var self = this;
        d3.csv("data/trends_september.csv", function(data){
            data.field = _.str.slugify(data.field);
            switch(data.field){
                case "technologie": data.field = "tech"; break;
                case "socle-technique": data.field = "society"; break;
                case "methode-process": data.field = "business"; break;
            }

            data.status = _.str.slugify(data.status);
            switch(data.status){
                case "deploiement": data.status = "act"; break;
                case "analyse": data.status = "prepare"; break;
                case "incubation": data.status = "watch"; break;
            }
            data.size = _.str.slugify(data.size);
            data.slugTrend = _.str.slugify(data.trend);
            var splittedLinks = data.links.split(/\n/g);
            splittedLinks = _.without(splittedLinks, "");
            data.strLinks = splittedLinks;
            if(data.strLinks[0] == "") data.strLinks = [];
            data.links = [];
            data.chapo = data.chapo.replace(/\n/g, '<br />');
            data.at_stake = data.at_stake.replace(/\n/g, '<br />');
            self.trends[data.id] = data;
        }, function(error, rows) {
            self.autocompleteTrends = _.map(self.trends, function(t){
                return {
                    label:t.trend,
                    value:t.id
                };
            });
            console.log(error, rows);
            return callback();
        });
    },

    computeTrends:function(){
        var self = this;
        _.each(this.trends, function(trend){
            _.each(trend.strLinks, function(link){
                var slugTrend = _.str.slugify(link);
                trend.links.push(slugTrend);
                var foundLinkedTrend = _.find(self.trends, function(t){ return t.slugTrend == slugTrend; });
                if(foundLinkedTrend !== undefined){
                    self.trends[foundLinkedTrend.id].links.push(trend.slugTrend);
                }else{
                    console.log("NOT GOOD TREND ID", trend, slugTrend);
                }
                
            });
        });

        _.each(this.trends, function(trend){
            trend.links = _.without(_.uniq(trend.links), "");
        });

        this.fields = _.groupBy(this.trends, function(t){
            return t.field;
        });

        delete this.fields[""];
    },

    */

    computeOrderedIntroTrends:function(){
        this.orderedIntroTrends = _.union(this.polarTrends["tech-act_row1"],this.polarTrends["society-act_row1"], this.polarTrends["business-act_row1"], this.polarTrends["tech-act_row2"], this.polarTrends["society-act_row2"], this.polarTrends["business-act_row2"], this.polarTrends["tech-act_row3"], this.polarTrends["society-act_row3"], this.polarTrends["business-act_row3"], this.polarTrends["tech-prepare"], this.polarTrends["society-prepare"], this.polarTrends["business-prepare"], this.polarTrends["tech-watch"], this.polarTrends["society-watch"], this.polarTrends["business-watch"]);

        this.orderedIntroTrendsSecond = _.union(this.polarTrendsSecond["tech-act_row1"],this.polarTrendsSecond["society-act_row1"], this.polarTrendsSecond["business-act_row1"], this.polarTrendsSecond["tech-act_row2"], this.polarTrendsSecond["society-act_row2"], this.polarTrendsSecond["business-act_row2"], this.polarTrendsSecond["tech-act_row3"], this.polarTrendsSecond["society-act_row3"], this.polarTrendsSecond["business-act_row3"], this.polarTrendsSecond["tech-prepare"], this.polarTrendsSecond["society-prepare"], this.polarTrends["business-prepare"], this.polarTrendsSecond["tech-watch"], this.polarTrendsSecond["society-watch"], this.polarTrends["business-watch"]);
    },

    reorganizeTrends:function(polarTrends, polarRowID){
        var firstLevels = _.filter(polarTrends, function(t){ return t.level == "first"; });
        var secondLevels = _.filter(polarTrends, function(t){ return t.level == "second"; });

        if(secondLevels.length > 0){
            var reorganizedTrends = [];
            var incFirstLevel = 0;
            var incSecondLevel = 0
            for(var i=0 ; i<(firstLevels.length + secondLevels.length) ; i++){
                if((i%2 == 0 )){
                    if(firstLevels[incFirstLevel] !== undefined){
                        reorganizedTrends.push(firstLevels[incFirstLevel]);
                        incFirstLevel += 1;
                    }else{
                        reorganizedTrends.push(secondLevels[incSecondLevel]);
                        incSecondLevel += 1;
                    }
                }else{
                    if(secondLevels[incSecondLevel] !== undefined){
                        reorganizedTrends.push(secondLevels[incSecondLevel]);
                        incSecondLevel += 1;
                    }else{
                        reorganizedTrends.push(firstLevels[incFirstLevel]);
                        incFirstLevel += 1;
                    }
                }
            }
            if(polarRowID == "watch") return reorganizedTrends.reverse();
            return reorganizedTrends;
        }else{
            return _.sortBy(polarTrends, function(t){ return t.trend; });
        }
    },

    isTouchDevice:function() {
      return 'ontouchstart' in window        // works on most browsers 
          || navigator.maxTouchPoints;       // works on IE10/11 and Surface
    }
});

module.exports = Utils;;